module.exports = __webpack_public_path__ + "static/media/django.c38ac2ca.png";